"use client";

import { useToast } from "@/src/hooks/use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/src/components/ui/toast";
import { PointerInfoProps } from "@/src/components/dashboard/features/map-windows/types/map.types";
import PointerInfo from "@/src/components/dashboard/features/map-windows/maps/pointer-details";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid w-full">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description &&
                (typeof description === "string" ? (
                  <ToastDescription>{description}</ToastDescription>
                ) : (
                  <PointerInfo {...(description as PointerInfoProps)} />
                ))}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
